document.querySelectorAll('.new-deals-outer a').forEach((el) => {
    el.setAttribute('tabindex', '0');
    el.setAttribute('role', 'button');
});

// CPW Script for managing click event on entering of Enter/Return key
document.addEventListener('keydown', function(e) {
    const el = e.target;
    const isTestTabindex = el.classList.contains('tabindexFocusEl');
    const isButtonRole = el.hasAttribute('role');
    const isTabbable = el.getAttribute('tabindex') === '0';

    if (isTestTabindex && isButtonRole && isTabbable) {
        if (e.key === 'Enter' || e.key === 'Return' || e.key === ' ') {
            e.preventDefault();
            el.click();
        }
    }
});

let lastFocusedBeforeModal = null;
let nextElement = null;

// Save the last focused element before modal opens
document.addEventListener('focusin', (e) => {
    if (!document.body.classList.contains('modal-open')) {
        lastFocusedBeforeModal = e.target;
    }
    if ((e.target.classList.contains('copyPromoPdpHandset')) || (e.target.classList.contains('promoCopySimo')) || (e.target.classList.contains('putTagCopy')) || (e.target.classList.contains('putTagCopySimo'))) {
        const current = e.target;
        nextElement = getNextTabbable(current);
    }
});

// When modal closes, Bootstrap removes .modal-open from body
// document.addEventListener('transitionend', () => {
//     const modalIsClosed = !document.querySelector('.modal.show');

//     if (modalIsClosed && lastFocusedBeforeModal) {
//         lastFocusedBeforeModal.focus();
//     }
// });

$(document).on('hidden.bs.modal', '.modal', function () {
        const modalIsClosed = !document.querySelector('.modal.show');

    if (modalIsClosed && lastFocusedBeforeModal) {
        lastFocusedBeforeModal.focus();
    }
});


// Fix for keyborad focus after copy to clipboard for next tabbable element
function getNextTabbable(el) {
    const focusable = Array.from(
        document.querySelectorAll(
            'a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])'
        )
    ).filter(x => !x.disabled && x.offsetParent !== null);

    const index = focusable.indexOf(el);
    return focusable[index + 1] || null;
}

const triggerClasses = [
    'copyPromoPdpHandset',
    'promoCopySimo',
    'putTagCopy',
    'putTagCopySimo'
];

function isTriggerElement(el) {
    return (
        el &&
        el.classList.contains('tabindexFocusEl') &&
        triggerClasses.some(cls => el.classList.contains(cls))
    );
}
// Enter / Space
document.addEventListener('keydown', (e) => {
    if ((e.key === 'Enter' || e.key === ' ' || e.code === 'Space') && isTriggerElement(e.target)) {
        e.preventDefault();
        // Keep focus on same CTA
        setTimeout(() => {
            e.target.focus();
        }, 0);
    }
});
// Mouse click
document.addEventListener('click', (e) => {
    const el = e.target.closest('.tabindexFocusEl');
    if (isTriggerElement(el)) {
        setTimeout(() => {
            el.focus();
        }, 0);
    }
});

// Script to handle insurance radio button keyboard focus
document.addEventListener('keydown', function(e) {
    if (e.key === 'Enter' || e.key === ' ' || e.key === 'Return') {
        const wrapper = e.target.closest('.insurance-choice-wrapper-list');
        if (!wrapper) {
            return;
        }
        const radio = wrapper.querySelector('input[type="radio"]');
        if (radio) {
            e.preventDefault();
            radio.click();
        }
    }
});

function trapFocus(modal) {
    if (modal.dataset.trapFocusBound) {
        return;
    }
    modal.dataset.trapFocusBound = 'true';
    const focusableSelectors =
        'a[href], button:not([disabled]), input:not([disabled]), ' +
        'select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

    const focusableElements = modal.querySelectorAll(focusableSelectors);
    if (!focusableElements.length) {
        return;
    }

    const first = focusableElements[0];
    modal.addEventListener('keydown', function(e) {
        if (e.key !== 'Tab') {
            return;
        }

        const focusables = Array.from(
            modal.querySelectorAll(
                'a[href], button:not([disabled]), input:not([disabled]), ' +
            'select:not([disabled]), textarea:not([disabled]), ' +
            '[tabindex]:not([tabindex="-1"])'
            )
        ).filter(el =>
            !el.hasAttribute('aria-hidden') &&
        el.offsetParent !== null
        );

        if (!focusables.length) {
            return;
        }

        const first = focusables[0];
        const last = focusables[focusables.length - 1];

        if (e.shiftKey && document.activeElement === first) {
            e.preventDefault();
            last.focus();
        }

        if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault();
            first.focus();
        }
    });

    modal.addEventListener('focusin', function(e) {
        if (e.target === modal) {
            first.focus();
        }
    });
}
// eslint-disable-next-line no-unused-vars
const addTabIndex = (hstarid) => {
    const modal = document.querySelector('#tariff-' + hstarid + '-modal');
    const activeLink = modal.querySelector('li.nav-item.active a.nav-link');
    const previouslyModified = modal.querySelectorAll('a.nav-link.tabindexFocusEl');

    previouslyModified.forEach((el) => {
        el.classList.remove('tabindexFocusEl');
        el.removeAttribute('tabindex');
    });
    $('#tariff-' + hstarid + '-modal').off('shown.bs.modal').on('shown.bs.modal', function() {
        const $btn = $(this).find('.add-to-basket-buyNowbtn').first();
        const $link = $btn.closest('a');

        if ($link.length) {
            $link.attr('tabindex', '0');
            setTimeout(() => {
                requestAnimationFrame(() => {
                    $link.trigger('focus');
                });
            }, 0);
        }
    });
    if (modal && activeLink) {
        const allNavLinks = modal.querySelectorAll('li.nav-item > a.nav-link');
        const allTabs = modal.querySelectorAll('div.panel-heading > a.accordion-toggle');
        allNavLinks.forEach((link) => {
            link.setAttribute('tabindex', '0');
            link.classList.add('tabindexFocusEl');
        });
        allTabs.forEach((tabs) => {
            tabs.setAttribute('tabindex', '0');
            tabs.classList.add('tabindexFocusEl');
            tabs.setAttribute('role', 'button');
            if (!tabs.hasAttribute('aria-expanded')) {
                const targetId = tabs.getAttribute('href') || tabs.getAttribute('data-target');
                const targetEl = targetId ? modal.querySelector(targetId) : null;
                const isExpanded = targetEl ? targetEl.classList.contains('in') : false;
                tabs.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
            }
        });
    }
    if (modal) {
        trapFocus(modal);
        modal.setAttribute('tabindex', '-1');
        modal.focus();
    }
};

// Sortby keyboard activation
(() => {
    const s = document.getElementById('search-sort');
    if (!s) {
        return;
    }
    const open = () => {
        if (typeof s.showPicker === 'function') {
            s.showPicker();
        } else {
            s.click();
        }
    };
    s.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowDown') {
            e.preventDefault();
            open();
        }
    });
})();

// Filter Menu close keyboard activation
document.addEventListener('DOMContentLoaded', () => {
    const btn = document.querySelector('[data-toggle-filters].close-filter-menu');
    if (!btn) {
        return;
    }

    btn.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === '') {
            e.preventDefault();
            btn.click();
        }
    });
});

document.querySelectorAll('.payment-out-of-stock, .out-of-stock-color, .in-active, [disabled]')
    .forEach((el) => {
        el.setAttribute('tabindex', '-1');
        el.setAttribute('aria-hidden', 'true');
    });
// Keyboard foucs for select Address
const selectAddress = document.querySelector('.focus-select-after-address');
if (selectAddress) {
    const observer = new MutationObserver(() => {
        if (selectAddress.options.length > 0) {
            selectAddress.focus();
            observer.disconnect();
        }
    });
    observer.observe(selectAddress, {
        childList: true
    });
}
const el = document.querySelector(
    '.title-summary .info-link[data-toggle="modal"]'
);

if (el) {
    el.setAttribute('tabindex', '0');
    el.setAttribute('role', 'button');
    el.classList.add('tabindexFocusEl');
}
// Code to handle focus after returning from modal
document.querySelectorAll('.info-link').forEach((el) => {
    // Check if this .info-link is inside an element with class .title-summary
    if (el.closest('.title-summary')) {
        el.setAttribute('tabindex', '0');
        el.setAttribute('role', 'button');
        el.classList.add('tabindexFocusEl');
    }
});

document.querySelectorAll('.tariff-info-link').forEach((el) => {
    // Check if this .tariff-info-link is inside an element with class .pdpDealNetworkInfo
    if (el.closest('.pdpDealNetworkInfo')) {
        el.setAttribute('tabindex', '0');
        el.setAttribute('role', 'button');
        el.classList.add('tabindexFocusEl');
    }
});
// Makes PDP slider bullets fully accessible:
const pag = document.querySelector('.gallery-pagination');
if (pag) {
    pag.setAttribute('tabindex', '0');
}
document.addEventListener('focusin', function(e) {
    const t = e.target;
    if (!t || !t.classList || !t.classList.contains('gallery-pagination')) {
        return;
    }

    const bullets = document.querySelectorAll('.swiper-pagination-bullet');
    for (let i = 0; i < bullets.length; i++) {
        const b = bullets[i];
        b.setAttribute('role', 'button');
        b.setAttribute('tabindex', '0');
        b.setAttribute('aria-label', 'Go to Slider ' + (i + 1));
        b.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                b.click();
            }
        });
    }

    const a = document.querySelector('.swiper-pagination-bullet-active') ||
            document.querySelector('.swiper-pagination-bullet');
    if (a && a.focus) {
        a.focus();
    }
});

let activatedByKeyboard = false;
// Listen globally for keydown on ANY link
document.addEventListener('keydown', function(ev) {
    if ((ev.key === 'Enter' || ev.key === ' ') && ev.target.tagName === 'A') {
        activatedByKeyboard = true;
    }
});
// call clickevent on click of quicklinks
document.addEventListener('click', function(e) {
    if (e.target.tagName === 'A') {
        const link = e.target;
        if (activatedByKeyboard) {
            activatedByKeyboard = false;
            setTimeout(() => {
                const targetSection = link.dataset.target;
                const viewAll = document.querySelector('.' + targetSection);
                if (viewAll) {
                    viewAll.focus();
                }
            }, 300);
        }
    }
});

// Filter focus trap
let trap, btn = document.querySelector('[data-toggle-filters]');
document.querySelectorAll('[data-toggle-filters]').forEach(b => b.onclick = () => setTimeout(() => {
    let c = document.querySelector('[data-filters-input-container]'),
        x = document.querySelector('.closeMenu'),
        f = c && x && c.querySelectorAll('a,button,input,select,textarea,[tabindex]:not([tabindex="-1"])');
    if (!f || !f.length) {
        return;
    }
    let last = f[f.length - 1];
    x.tabIndex = 0; x.focus();
    document.removeEventListener('focusin', trap);
    document.addEventListener('focusin', trap = (e) => {
        if (!c.contains(e.target)) {
            x.focus();
        }
    });
    c.onkeydown = (e) => {
        if (e.key !== 'Tab') {
            return;
        }
        if (e.shiftKey && document.activeElement === x) {
            e.preventDefault(); last.focus();
        }
        if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault(); x.focus();
        }
    };
    x.onkeydown = (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault(); x.click();
        }
    };
    x.onclick = () => (document.removeEventListener('focusin', trap), btn && btn.focus());
}, 200));

// Mega Menu focus trap
document.addEventListener('keydown', function(e) {
    if (e.key !== 'Tab') {
        return;
    }
    const trigger = document.querySelector('.callMenus.active > a');
    const menu = document.querySelector('.mobileMenu.open');
    if (!trigger || !menu) {
        return;
    }
    const focusables = menu.querySelectorAll('a, button, input, [tabindex]:not([tabindex="-1"])');
    if (!focusables.length) {
        return;
    }
    const first = focusables[0];
    const last = focusables[focusables.length - 1];

    if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        trigger.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        trigger.focus();
    } else if (document.activeElement === trigger && !e.shiftKey) {
        e.preventDefault();
        first.focus();
    }
});

document.addEventListener('keydown', function(e) {
    if (e.key !== 'Tab') {
        return;
    }
    const modal = document.querySelector('.modal');
    const closeBtn = modal.querySelector('.modal-header .close');
    const lastAddBtn = modal.querySelectorAll('.add-to-basket-btn');
    if (!closeBtn || !lastAddBtn.length) {
        return;
    }

    const lastButton = lastAddBtn[lastAddBtn.length - 1];

    // If user is tabbing forward on the last button → move to close button
    if (!e.shiftKey && document.activeElement === lastButton) {
        e.preventDefault();
        closeBtn.focus();
    }
});
document.addEventListener('keydown', function(e) {

    if (e.key !== 'Tab') {
        return;
    }

    const cells = Array.from(
        document.querySelectorAll("td[tabindex='0']")
    ).sort((a, b) => Number(a.dataset.order) - Number(b.dataset.order));

    const current = document.activeElement;
    let index = cells.indexOf(current);

    if (index === -1) {
        return;
    }

    if (!e.shiftKey && index === cells.length - 1) {
        return;
    }

    if (e.shiftKey && index === 0) {
        return;
    }

    e.preventDefault();

    if (e.shiftKey) {
        index = index - 1;
    } else {
        index = index + 1;
    }

    cells[index].focus();
});

// Pause Carousel When It Receives Focus & Arrow Keys Navigate Between Slides
(function() {
    let carousel = document.getElementById('home-carousel');
    if (!carousel || !window.jQuery) {
        return;
    }

    let $carousel = jQuery(carousel);
    let indicators = carousel.querySelectorAll('.carousel-indicators li');

    carousel.addEventListener('focusin', function() {
        $carousel.carousel('pause');
    });

    indicators.forEach(function(dot, index) {
        dot.setAttribute('tabindex', '0');

        dot.addEventListener('keydown', function(e) {
            e.stopPropagation();

            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                $carousel.carousel(index);
            } else if (e.key === 'ArrowRight') {
                e.preventDefault();
                let next = indicators[index + 1] || indicators[0];
                next.focus();
            } else if (e.key === 'ArrowLeft') {
                e.preventDefault();
                let prev = indicators[index - 1] || indicators[indicators.length - 1];
                prev.focus();
            }
        });
    });
    carousel.addEventListener('focusout', function(e) {
        if (!carousel.contains(e.relatedTarget)) {
            $carousel.carousel('cycle');
        }
    });
})();
// Prevent screen readers and focus from accessing background content
$('.modal').on('shown.bs.modal', function() {
    const modal = this;

    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');

    document.querySelectorAll('body > *').forEach((el) => {
        if (el !== modal) {
            el.setAttribute('aria-hidden', 'true');
        }
    });

    modal.setAttribute('tabindex', '-1');
    modal.focus();
    // modal.addEventListener('focus', (e) => {
    //     if (e.target === modal) {
    //         const firstButton = modal.querySelector('button, a');
    //         if (firstButton) {
    //             firstButton.focus();
    //         }
    //     }
    // }, true);
});

$('.modal').on('hidden.bs.modal', function() {
    document.querySelectorAll('[aria-hidden="true"]').forEach((el) => {
        el.removeAttribute('aria-hidden');
    });
});
// For basket icon added aria-hidden and alt attribute
function updateBasketAriaAttribute() {
    document.querySelectorAll('.desktop-basket-accessbility').forEach((el) => {
        if (window.innerWidth > 1023) {
            el.setAttribute('aria-hidden', 'true');
            (el.tagName === 'IMG' ? [el] : el.querySelectorAll('img'))
                .forEach(img => img.setAttribute('alt', ''));
        } else {
            el.removeAttribute('aria-hidden');
            (el.tagName === 'IMG' ? [el] : el.querySelectorAll('img'))
                .forEach(img => img.setAttribute('alt','Basket'));
        }
    });
}
updateBasketAriaAttribute();
window.addEventListener('resize', updateBasketAriaAttribute);
$('#home-carousel').on('slid.bs.carousel', function() {
    let indicators = $(this).find('.carousel-indicators li');
    let activeIndex = indicators.index(indicators.filter('.active'));

    indicators.each(function(index) {
        let $el = $(this);

        // aria-selected
        $el.attr('aria-selected', index === activeIndex ? 'true' : 'false');

        // accessible name
        if (index === activeIndex) {
            $el.attr('aria-label', 'Current slide');
        } else if (index < activeIndex) {
            $el.attr('aria-label', 'Previous slide');
        } else {
            $el.attr('aria-label', 'Next slide');
        }
    });
});

// Aria-expanded for close button in navigation
const menuToggle = document.querySelector('.menu-toggle-nav');
menuToggle.addEventListener('click', () => {
    const expanded = menuToggle.getAttribute('aria-expanded') === 'true';

    menuToggle.setAttribute('aria-expanded', !expanded);
    menuToggle.setAttribute(
        'aria-label',
        expanded ? 'Open menu' : 'Close menu'
    );
    menuToggle.closest('.callMenus')
        .classList.toggle('active');
});

// Footer aria-expanded toggle
document.querySelectorAll('.footerExpMainCat').forEach((item) => {
    item.addEventListener('click', () => {
        const expanded =
            item.getAttribute('aria-expanded') === 'true';
        item.setAttribute('aria-expanded', !expanded);
    });
});

// search listbox aria-expanded toggle
(() => {
    const panel = document.querySelector('.searchResultsDropDown');
    const searchInput = document.getElementById('searchText');

    if (!panel || !searchInput) {
        return;
    }
    const updateState = () => {
        searchInput.setAttribute(
            'aria-expanded',
            panel.classList.contains('show')
        );
    };

    new MutationObserver(updateState).observe(panel, {
        attributes: true,
        attributeFilter: ['class']
    });

    updateState();
})();

// The number of search results in the Search listbox are programatically determined
const searchInput = document.getElementById('searchText');
const searchStatus = document.getElementById('search-status');
const pinnedContainer = document.querySelector('[data-pinned-search-results-container]');
const searchPanel = document.querySelector('.searchResultsDropDown');

let t;

const getTotalResultsCount = () => {
    if (!pinnedContainer || !searchPanel) {
        return 0;
    }

    return (
        pinnedContainer.querySelectorAll(
            '.pinned-search-result:not(.hide), .pinned-search-result-text:not(.hide)'
        ).length +
        Array.from(searchPanel.querySelectorAll('.dropdown-item')).filter(function(i) {
            return i && i.closest('a') && !/no match|please try again/i.test(i.textContent || '');
        }).length
    );
};

const updateSearchStatus = () => {
    if (!searchInput || !searchStatus) {
        return;
    }

    let q = (searchInput && searchInput.value) ? searchInput.value.trim() : '';
    if (!q) {
        searchStatus.textContent = '';
        return;
    }

    let total = getTotalResultsCount();

    searchStatus.textContent =
        total === 0
            ? 'No search results available.'
            : total === 1
                ? '1 search result available.'
                : total + ' search results available.';
};

const schedule = function() {
    clearTimeout(t);
    t = setTimeout(updateSearchStatus, 300);
};

if (searchInput) {
    searchInput.addEventListener('input', schedule);
}

if (searchPanel) {
    new MutationObserver(schedule).observe(searchPanel, {
        childList: true,
        subtree: true
    });
}

// aria-label for search results listbox
const updateDropdownAccessibility = () => {
    const searchPanel = document.querySelector('.searchResultsDropDown');
    if (!searchPanel) {
        return;
    }
    const searchQuery = searchInput.value.trim();

    if (!searchQuery) {
        searchPanel.removeAttribute('role');
        searchPanel.removeAttribute('aria-label');
        return;
    }

    searchPanel.setAttribute('role', 'group');
    searchPanel.setAttribute(
        'aria-label',
        `Search results for ${searchQuery}`
    );
};

searchInput.addEventListener('input', () => {
    setTimeout(updateDropdownAccessibility, 300);
});

// search button & close aria-expanded
document.querySelector('.searchTogglenavButton')
    .addEventListener('click', function() {

        const isExpanded =
            this.getAttribute('aria-expanded') === 'true';

        this.setAttribute('aria-expanded', !isExpanded);

        this.setAttribute(
            'aria-label',
            isExpanded ? 'Search products' : 'Close search'
        );
    });

//CDMA-624
(function () {

    function handleClickOrKey(event) {
        var el = event.currentTarget;

        // Keyboard support
        if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') {
            return;
        }

        if (el.getAttribute('role') === 'tab') {
            handleTab(el);
        }

        if (el.getAttribute('role') === 'button' && el.hasAttribute('aria-expanded')) {
            handleAccordion(el);
        }
    }

    function handleTab(activeTab) {
        var tabList = activeTab.closest('[role="tablist"]');
        if (!tabList) return;

        var tabs = tabList.querySelectorAll('[role="tab"]');
        tabs.forEach(function (tab) {
            tab.setAttribute('aria-selected', 'false');
        });

        activeTab.setAttribute('aria-selected', 'true');
    }

    function handleAccordion(button) {
        var expanded = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', String(!expanded));
    }

    // Attach listeners
    document.querySelectorAll('[role="tab"], [role="button"][aria-expanded]')
        .forEach(function (el) {
            el.addEventListener('click', handleClickOrKey);
            el.addEventListener('keydown', handleClickOrKey);
        });

})();

$('.fpdaccessbility .nav-link').on('shown.bs.tab', function() {
    $('.fpdaccessbility .nav-item').attr('aria-selected', 'false');
    $(this).closest('.nav-item').attr('aria-selected', 'true');
});

// Tradin Table focus order
const container = document.querySelector('#tradeinTableFocusOrder');
if(container) {
    const items = [...container.querySelectorAll('[data-order]')]
        .sort((a, b) => a.dataset.order - b.dataset.order);
    items.forEach(e => e.tabIndex = 0);
    document.addEventListener('keydown', (e) => {
        if (e.key !== 'Tab') {
            return;
        }
        const activeInside = container.contains(document.activeElement);
        if (!activeInside) {
            return;
        }
        const i = items.indexOf(document.activeElement);
        if (i === -1) {
            return;
        }
        const next = i + (e.shiftKey ? -1 : 1);
        if (next < 0 || next >= items.length) {
            return;
        }
        e.preventDefault();
        items[next].focus();
    });
}

document.querySelectorAll('.new-deals-outer a').forEach((el) => {
    el.setAttribute('tabindex', '0');
    el.setAttribute('role', 'button');
    el.classList.add('tabindexFocusEl');
});

// PROMOTION MODAL ACCESSIBILITY FIX
let modalTriggerElement = null;
const modalTriggerSelector =
    '.promoModalToggle,' +
    '.promoPDPModalToggle,' +
    '.promoModalToggleExtras,' +
    '.promoInfo,' +
    '.promoInfoTopPicks,' +
    '.giftPromoInfoIcon,' +
    '.info-link,' +
    '.tariff-info-link';
const copyButtonSelector =
    '.copyPromoPdpHandset,' +
    '.promoCopySimo,' +
    '.putTagCopy,' +
    '.putTagCopySimo,' +
    '.putTagModalIconCopy';

// Capture Exact Trigger
document.addEventListener('click', function (e) {
    const trigger = e.target.closest(modalTriggerSelector);
    if (trigger) {
        modalTriggerElement = trigger;
    }
}, true);
document.addEventListener('keydown', function (e) {
    if ((e.key === 'Enter' || e.key === ' ') && e.target.matches(modalTriggerSelector)) {
        modalTriggerElement = e.target;
    }
}, true);

// Focusable Elements Utility
function getModalFocusableElements(modal) {
    return Array.prototype.slice.call(
        modal.querySelectorAll(
            'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex="0"]'
        )
    ).filter(function (el) {
        return (
            !el.disabled &&
            el.offsetParent !== null
        );
    });
}

// Modal Open, Keep focus on modal container
$(document).on('shown.bs.modal', '.promoModal', function () {
    const modal = this;
    modal.setAttribute('tabindex', '-1');
    setTimeout(function () {
        modal.focus();
    }, 0);
});

// Modal Close, Return focus to trigger
$(document).on('hidden.bs.modal', '.promoModal', function () {
    setTimeout(function () {
        if (modalTriggerElement && document.contains(modalTriggerElement)) {
            modalTriggerElement.focus();
        }
    }, 0);
});

// Modal Focus Trap
document.addEventListener('keydown', function (e) {
    const modal = document.querySelector('.promoModal.in');
    if (!modal) {
        return;
    }
    if (e.key !== 'Tab') {
        return;
    }
    const closeBtn =
        modal.querySelector('.button-close') ||
        modal.querySelector('.modal-header .close');
    if (!closeBtn) {
        return;
    }
    let focusables = getModalFocusableElements(modal);
    if (!focusables.length) {
        return;
    }
    const lastFocusable = focusables[focusables.length - 1];
    // Remove close button from the list
    focusables = focusables.filter(function (el) {
        return el !== closeBtn;
    });
    // First TAB from modal container
    if (!e.shiftKey && document.activeElement === modal) {
        e.preventDefault();
        closeBtn.focus();
        return;
    }
    // TAB from last element -> close button
    if (!e.shiftKey && document.activeElement === lastFocusable) {
        e.preventDefault();
        closeBtn.focus();
        return;
    }
    // SHIFT+TAB from close -> last element
    if (e.shiftKey && document.activeElement === closeBtn) {
        e.preventDefault();
        lastFocusable.focus();
        return;
    }
}, true);

// Force focus back inside modal
document.addEventListener('focusin', function (e) {
    const modal = document.querySelector('.promoModal.in');
    if (!modal) {
        return;
    }
    if (!modal.contains(e.target) && e.target !== modal) {
        const closeBtn = modal.querySelector('.button-close') || modal.querySelector('.modal-header .close');
        if (closeBtn) {
            closeBtn.focus();
        }
    }
});

// Copy CTA, KEEP focus on copy button
document.addEventListener('click', function (e) {
    const copyBtn = e.target.closest(copyButtonSelector);
    if (!copyBtn) {
        return;
    }
    requestAnimationFrame(function () {
        copyBtn.focus();
    });
}, true);
document.addEventListener('keydown', function (e) {
    const copyBtn = e.target.closest(copyButtonSelector);
    if (e.key !== 'Enter' && e.key !== ' ') {
        return;
    }
    if (!copyBtn) {
        return;
    }
    requestAnimationFrame(function () {
        copyBtn.focus();
    });
}, true);